let testimonial_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'testimonials', name: 'testimonials.list', component: () => import('./pages/Index.vue') },
      { path: 'testimonials/create', name: 'testimonials.create', component: () => import('./pages/Create.vue') },
      { path: 'testimonials/:id/edit', name: 'testimonials.edit', component: () => import('./pages/Edit.vue') }
    ]
  }
];

export default testimonial_routes;
